import script from './checkbox.vue_vue_type_script_lang.mjs';
export { default } from './checkbox.vue_vue_type_script_lang.mjs';
import { render } from './checkbox.vue_vue_type_template_id_2c9881e5_lang.mjs';

script.render = render;
script.__file = "packages/components/checkbox/src/checkbox.vue";
//# sourceMappingURL=checkbox.mjs.map
